<template>
  <div>
    <List
        v-bind:headers="headers"
        v-bind:formview="formview"
        v-bind:table="table"
        v-bind:addbutton="true"
        v-bind:default_limit="'1500'"
        v-bind:default_sort="'name'"
        v-bind:default_sort_typ="'ASC'"
        v-bind:extension="''"
    ></List>
  </div>
</template>

<script>

import List from '@/components/ListDefault'

export default {
  name: "ListMedium",

  components: {
    List,
  },

  data () {
    return {
      search: '',
      formview: 'FormMedium',
      table: 'medium',
    }
  },

  computed: {
    headers () {
      return [
        { text: 'Name', align: 'start', sortable: true, value: 'name' },
        { text: 'Ort', value: 'ort' },
        { text: 'Auflage/Visits', value: 'auflage' },
       //  { text: 'Reichweite', value: 'reichweite' },
        { text: 'Gattung', value: 'gattung' },
        { text: 'Erscheinungsweise', value: 'erscheinungsweise' },
        { text: 'Redaktion E-Mail', value: 'email' },
        { text: '', value: 'edit' },
      ]
    },
  },




}
</script>

<style scoped>

</style>
